export const EAZY_CONSTANTS = {
  TIMEOUT_MS: 10000,
  PAGE_SIZE: 10,
  SCROLL_THRESHOLD: 50,
} as const;

export const EAZY_STATUS = {
  CREATED: "CREATED",
  CREATE_FAILED: "CREATE_FAILED",
  UPDATED: "UPDATED",
  UPDATE_FAILED: "UPDATE_FAILED",
  DELETED: "DELETED",
} as const;

export const EAZY_COLORS = {
  SUCCESS: "#00A63E",
  ERROR: "#FF4D4F",
  WARNING: "#D46B08",
  TEXT_PRIMARY: "#000000",
  TEXT_SECONDARY: "#6A7282",
  TEXT_DISABLED: "#00000040",
  BACKGROUND_GRAY: "#F9FAFB",
  BORDER_GRAY: "#E5E7EB",
  BORDER_DEFAULT: "#D1D5DC",
} as const;
